import React, { Component } from 'react';
import ApiManager from '../../../apiManager';
import { doubleNumber, trans } from '../../../helpers';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import TableHook from '../../../hooks/table';
import config from '../../../baseConfig';
import Loading from '../../Fragments/Loading';
import FormMiddlewareError from '../../Fragments/FormMiddlewareError';

class B2bApplications extends Component {

    constructor( props ){
        super( props );

        this.state = {
            appNumber: '',
            appInn: '',
            appBan: '',
            appCtn: '',
            appEmail: '',
            searchData: '',
            startDate: '',
            endDate: '',
            searchByBoxVisible: false,
            appTypeOptions: [],
            appTypeSelectedOption: null,
            appStatusSelectedOption: null,
            searchButtonDisabled: false
        };

        // Component props
        this.componentIsMounted = true;
        this.startDatepickerRef = React.createRef();

        // Bind own methods
        this.getAllApplicationsSuccess = this.getAllApplicationsSuccess.bind( this );
        this.searchApplicationsSuccess = this.searchApplicationsSuccess.bind( this );
        this.applicationEditLink = this.applicationEditLink.bind( this );
        this.getAppTypesSuccess = this.getAppTypesSuccess.bind( this );

    }

    componentDidMount() {

        this.getAllApplications();

        // Get types
        ApiManager.getRequest({}, '/application/types').then( this.getAppTypesSuccess, this.props.errorCallBack );

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {

        if ( nextProps.curator === 'curator' && nextProps.profileData !== '' ) {
            nextState.appInn = nextProps.profileData.data.inn;
        }

        return nextState;

    }

    componentWillUnmount(){

        this.componentIsMounted = false;
        this.startDatepickerRef = null;

    }

    getAppTypesSuccess({ data }){

        if ( !this.componentIsMounted ) {
            return;
        }

        if ( data.status === 'OK' ) {

            this.setState({
                appTypeOptions: data.data.types.map(({ id, title }) => ({ "label": title, "value": id }))
            });

        }

    }

    appStatusOptions(){

        return [
            { value: 0, label: trans( this.props.b2bTrans, 'b2b.application.status_0' ) },
            { value: 1, label: trans( this.props.b2bTrans, 'b2b.application.status_1' ) },
            { value: 2, label: trans( this.props.b2bTrans, 'b2b.application.status_2' ) },
            { value: 3, label: trans( this.props.b2bTrans, 'b2b.application.status_3' ) }
        ];

    }

    checkBySeconds( d ){

        return Math.floor( d.getTime() / 1000 );

    }

    getAllApplicationsSuccess({ data }){

        if ( !this.componentIsMounted ) {
            return;
        }

        this.setState({
            searchData: data
        });

    }

    getAllApplications(){

        this.setState({
            searchData: ''
        });

        ApiManager.getRequest({
            jwt: this.props.getDecryptedToken()
        }, '/b2b' + this.props.curator + '/application').then( this.getAllApplicationsSuccess, this.props.errorCallBack );

    }

    searchApplicationsSuccess({ data }){

        if ( !this.componentIsMounted ) {
            return;
        }

        this.setState({
            searchData: data,
            searchButtonDisabled: false
        })

    }

    searchApplications(){

        this.setState({
            searchData: '',
            searchButtonDisabled: true
        });

        let fromDate = this.state.startDate,
            toDate = this.state.endDate;

        if ( fromDate ) {
            fromDate = doubleNumber( fromDate.getDate()) + '-' + doubleNumber( fromDate.getMonth()+1 ) + '-' + fromDate.getFullYear();
        }

        if ( toDate ) {
            toDate = doubleNumber( toDate.getDate()) + '-' + doubleNumber( toDate.getMonth()+1 ) + '-' + toDate.getFullYear();
        }

        ApiManager.postRequest({
            _token: this.props.csrf_token.data,
            jwt: this.props.getDecryptedToken(),
            id: this.state.appNumber,
            date_from: fromDate,
            date_to: toDate,
            email: this.state.appEmail,
            inn: this.state.appInn,
            ban: this.state.appBan,
            application_type: this.state.appTypeSelectedOption !== null ? this.state.appTypeSelectedOption.value : '',
            ctn: this.state.appCtn,
            application_status: this.state.appStatusSelectedOption !== null ? this.state.appStatusSelectedOption.value : ''
        }, '/b2b' + this.props.curator + '/application/search').then( this.searchApplicationsSuccess, this.props.errorCallBack );

    }

    searchByBox(){

        if ( !this.state.searchByBoxVisible ) {
            return '';
        }

        const { searchData } = this.state;

        let errorEmailClass = '',
            errorEmailBox = '',
            errorInnClass = '',
            errorInnBox = '',
            errorBanClass = '',
            errorBanBox = '',
            errorCtnClass = '',
            errorCtnBox = '',
            errorBox = '';

        if ( searchData !== '' ) {

            if ( searchData.status === 'INVALID_DATA' ) {

                if ( searchData.errors.hasOwnProperty('email') ) {
                    errorEmailClass = ' form-error';
                    errorEmailBox = <div className="form-error-text form-error-text--top-space fs11">{searchData.errors.email}</div>;
                }

                if ( searchData.errors.hasOwnProperty('inn') ) {
                    errorInnClass = ' form-error';
                    errorInnBox = <div className="form-error-text form-error-text--top-space fs11">{searchData.errors.inn}</div>;
                }

                if ( searchData.errors.hasOwnProperty('ban') ) {
                    errorBanClass = ' form-error';
                    errorBanBox = <div className="form-error-text form-error-text--top-space fs11">{searchData.errors.ban}</div>;
                }

                if ( searchData.errors.hasOwnProperty('ctn') ) {
                    errorCtnClass = ' form-error';
                    errorCtnBox = <div className="form-error-text form-error-text--top-space fs11">{searchData.errors.ctn}</div>;
                }

            }

            if ( searchData.status === 'ERROR' || searchData.status === 'NOT_FOUND' ) {

                errorBox = <FormMiddlewareError message={searchData.message} />;

            }

        }

        return (
            <div className="main-wrapper__sort-content pr">

                <form className="main-wrapper__sort-form" action="#" method="post" onSubmit={( event ) => {
                    event.preventDefault();
                    this.searchApplications();
                }}>
                    <div className="main-wrapper__sort-form-box ver-top-box">

                        <div className="main-wrapper__sort-form-label-box">
                            <label className="main-wrapper__sort-form-label fs14" htmlFor="app-number">{trans( this.props.b2bTrans, 'b2b.application.number_label' )}</label>
                        </div>
                        <input
                            className="main-wrapper__sort-form-field fs14"
                            type="text"
                            name="app-number"
                            id="app-number"
                            value={this.state.appNumber}
                            placeholder={trans( this.props.b2bTrans, 'b2b.application.number_placeholder' )}
                            onChange={({ target }) => this.setState({ appNumber: target.value.replace(/[^\d]/g, '') })}
                        />

                    </div>
                    <div className="main-wrapper__sort-form-box ver-top-box">

                        <div className="main-wrapper__sort-form-label-box">
                            <label className="main-wrapper__sort-form-label fs14" htmlFor="app-datepicker">{trans( this.props.b2bTrans, 'b2b.application.date_range_label' )}</label>
                        </div>
                        <div className="main-wrapper__sort-form-datepicker pr">
                            <div className="main-wrapper__sort-form-datepicker-current ver-top-box">
                                <div className="react-datepicker-wrapper">
                                    <div className="react-datepicker__input-container">
                                        <DatePicker
                                            selected={this.state.startDate}
                                            dateFormat="dd-MM-yyyy"
                                            onChange={( date ) => {

                                                let startDate = '',
                                                    endDate = this.state.endDate;

                                                if ( date !== null ) {
                                                    const newDate = new Date(date);
                                                    startDate = date;

                                                    if ( endDate ) {
                                                        endDate = ( this.checkBySeconds( date ) > this.checkBySeconds( this.state.endDate ) ) ? new Date( newDate.setDate(newDate.getDate()) ) : this.state.endDate;
                                                    }

                                                }

                                                this.setState({
                                                    startDate,
                                                    endDate
                                                });
                                            }}
                                            placeholderText={trans( this.props.b2bTrans, 'b2b.application.start_date_placeholder' )}
                                            ref={(c) => this.startDatepickerRef = c}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="main-wrapper__sort-form-datepicker-sep ver-top-box"></div>
                            <div className="main-wrapper__sort-form-datepicker-current ver-top-box">
                                <div className="react-datepicker-wrapper">
                                    <div className="react-datepicker__input-container">
                                        <DatePicker
                                            selected={this.state.endDate}
                                            dateFormat="dd-MM-yyyy"
                                            onChange={( date ) => {

                                                let startDate = this.state.startDate,
                                                    endDate = '';

                                                if ( date !== null ) {
                                                    const newDate = new Date(date);
                                                    endDate = date;

                                                    if ( startDate ) {
                                                        startDate = ( this.checkBySeconds( date ) < this.checkBySeconds( this.state.startDate ) ) ? new Date( newDate.setDate(newDate.getDate()) ) : this.state.startDate;
                                                    }

                                                }

                                                this.setState({
                                                    startDate,
                                                    endDate
                                                });

                                            }}
                                            placeholderText={trans( this.props.b2bTrans, 'b2b.application.end_date_placeholder' )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <button
                                className="main-wrapper__sort-form-datepicker-btn sprite pa"
                                type="button"
                                onClick={() => this.startDatepickerRef.setFocus()}
                            ></button>
                        </div>

                    </div>
                    <div className={`main-wrapper__sort-form-box ver-top-box${errorEmailClass}`}>

                        <div className="main-wrapper__sort-form-label-box">
                            <label className="main-wrapper__sort-form-label fs14" htmlFor="app-email">{trans( this.props.b2bTrans, 'b2b.application.email_label' )}</label>
                        </div>
                        <input
                            className="main-wrapper__sort-form-field main-wrapper__sort-form-field--min-w-280 fs14"
                            type="text"
                            name="app-email"
                            id="app-email"
                            value={this.state.appEmail}
                            onChange={({ target }) => this.setState({ appEmail: target.value.trim() })}
                            placeholder={trans( this.props.b2bTrans, 'b2b.application.email_placeholder' )}
                        />
                        {errorEmailBox}

                    </div>
                    <div className={`main-wrapper__sort-form-box ver-top-box${errorInnClass}`}>

                        <div className="main-wrapper__sort-form-label-box">
                            <label className="main-wrapper__sort-form-label fs14" htmlFor="app-inn">{trans( this.props.b2bTrans, 'b2b.application.inn_label' )}</label>
                        </div>
                        <input
                            className="main-wrapper__sort-form-field fs14"
                            type="text"
                            name="app-inn"
                            id="app-inn"
                            value={this.state.appInn}
                            onChange={({ target }) => this.setState({ appInn: target.value.replace(/[^\d]/g, '') })}
                            placeholder={trans( this.props.b2bTrans, 'b2b.application.inn_placeholder' )}
                            disabled={this.props.curator}
                        />
                        {errorInnBox}

                    </div>
                    <div className={`main-wrapper__sort-form-box ver-top-box${errorBanClass}`}>

                        <div className="main-wrapper__sort-form-label-box">
                            <label className="main-wrapper__sort-form-label fs14" htmlFor="app-ban">{trans( this.props.b2bTrans, 'b2b.application.ban_label' )}</label>
                        </div>
                        <input
                            className="main-wrapper__sort-form-field fs14"
                            type="text"
                            name="app-ban"
                            id="app-ban"
                            value={this.state.appBan}
                            onChange={({ target }) => this.setState({ appBan: target.value.replace(/[^\d]/g, '') })}
                            placeholder={trans( this.props.b2bTrans, 'b2b.application.ban_placeholder' )}
                        />
                        {errorBanBox}

                    </div>
                    <div className="main-wrapper__sort-form-box ver-top-box">

                        <div className="main-wrapper__sort-form-label-box">
                            <label className="main-wrapper__sort-form-label fs14" htmlFor="app-type">{trans( this.props.b2bTrans, 'b2b.application.type_label' )}</label>
                        </div>
                        <div className="application-form__select">
                            <Select
                                options={this.state.appTypeOptions}
                                value={this.state.appTypeSelectedOption}
                                onChange={( appTypeSelectedOption ) => this.setState({ appTypeSelectedOption })}
                                placeholder={trans( this.props.b2bTrans, 'b2b.application.select_default_label' )}
                                noOptionsMessage={() => trans( this.props.b2bTrans, 'b2b.application.select_no_options_message' )}
                            />
                        </div>
                    </div>
                    <div className={`main-wrapper__sort-form-box ver-top-box${errorCtnClass}`}>

                        <div className="main-wrapper__sort-form-label-box">
                            <label className="main-wrapper__sort-form-label fs14" htmlFor="app-ctn">{trans( this.props.b2bTrans, 'b2b.application.ctn_label' )}</label>
                        </div>
                        <input
                            className="main-wrapper__sort-form-field fs14"
                            type="text"
                            name="app-ctn"
                            id="app-ctn"
                            placeholder={trans( this.props.b2bTrans, 'b2b.application.ctn_placeholder' )}
                            value={this.state.appCtn}
                            onChange={({ target }) => this.setState({ appCtn: target.value.replace(/[^\d]/g, '') })}
                        />
                        {errorCtnBox}

                    </div>
                    <div className="main-wrapper__sort-form-box ver-top-box">

                        <div className="main-wrapper__sort-form-label-box">
                            <label className="main-wrapper__sort-form-label fs14" htmlFor="app-status">{trans( this.props.b2bTrans, 'b2b.application.status_label' )}</label>
                        </div>

                        <div className="application-form__select">
                            <Select
                                options={this.appStatusOptions()}
                                value={this.state.appStatusSelectedOption}
                                onChange={( appStatusSelectedOption ) => this.setState({ appStatusSelectedOption })}
                                placeholder={trans( this.props.b2bTrans, 'b2b.application.status.select_default_label' )}
                                noOptionsMessage={() => trans( this.props.b2bTrans, 'b2b.application.status.select_no_options_message' )}
                            />
                        </div>

                    </div>
                    <div className="main-wrapper__sort-btn-box ver-top-box">

                        <button
                            className={`application-form__action-btn btn btn--yellow monserrat-medium fs18 ver-top-box${this.state.searchButtonDisabled ? ' btn--loading' : ''}`}
                            type="submit"
                            disabled={this.state.searchButtonDisabled}
                        >{trans( this.props.b2bTrans, 'b2b.application.btn_title' )}</button>

                    </div>
                    <div className="main-wrapper__sort-btn-box ver-top-box">

                        <button
                            className="application-form__reset-btn fs18 ver-top-box"
                            type="button"
                            onClick={() => {
                                this.setState({
                                    appNumber: '',
                                    appInn: '',
                                    appBan: '',
                                    appCtn: '',
                                    appEmail: '',
                                    startDate: '',
                                    endDate: '',
                                    appTypeSelectedOption: null,
                                    appStatusSelectedOption: null
                                });
                                this.getAllApplications();
                            }}
                        >{trans( this.props.b2bTrans, 'b2b.application.btn_reset_title' )}</button>

                    </div>

                    {errorBox}

                </form>

            </div>
        );

    }

    applicationEditLink( id ){

        return (
            <button
                className="filter__more ver-top-box sprite-a pr"
                type="button"
                onClick={() => {
                    this.props.history.push( config.urlPrefix + this.props.urlPrefix + '/applicationEdit/' + id );
                    this.props.updatePath();
                }}
            >{trans( this.props.b2bTrans, 'b2b.application.table.app_more_btn_title' )}</button>
        );

    }

    filter(){

        const { searchData } = this.state;
        let table = <Loading withBox={true} />;

        if ( searchData !== '' ) {

            if ( searchData.status === 'OK' && searchData.data.application.length ) {

                table = <TableHook
                    data={Object.values( searchData.data.application )}
                    params={{
                        urlPrefix: this.props.urlPrefix,
                        history: this.props.history,
                        toEdit: this.applicationEditLink,
                        b2bTrans: this.props.b2bTrans,
                        curator: this.props.curator
                    }}
                />;

            } else {
                table = (
                    <p className="filter__empty-box tc" style={{ color: '#707982', padding: '20px' }}>No result.</p>
                );
            }

        }

        return table;

    }

    render(){

        return(
            <div className="main-wrapper__right-inner scroller-block pr">

                <div className="main-wrapper__right-content">

                    <h2 className="main-wrapper__title main-wrapper__title--with-border fb fs20">{trans( this.props.b2bTrans, 'b2b.application.title' )}</h2>

                    <div className="main-wrapper__sort-box">
                        <button
                            className={`main-wrapper__toggle-btn sprite-a fs18 monserrat-medium pr${this.state.searchByBoxVisible ? ' main-wrapper__toggle-btn--active' : ''}`}
                            type="button"
                            onClick={() => this.setState({ searchByBoxVisible: !this.state.searchByBoxVisible })}
                        >{trans( this.props.b2bTrans, 'b2b.application.search_by_title' )}</button>
                        {this.searchByBox()}
                    </div>
                    {this.filter()}
                </div>

            </div>
        );

    }

}

export default B2bApplications;